var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Observer } from 'mobx-react-lite';
import moment from 'moment';
import React from 'react';
import { reportError } from '../../utils/errors.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { YYYYMMDD } from '../../utils/time.utils';
import BaseCalendarWeek from './BaseCalendarWeek';
function BaseCalendarMonth(props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get calendar() {
            return p.state;
        },
        get startOfMonthMoment() {
            return moment(s.calendar.startDate);
        },
        get startOfCalendarMoment() {
            return moment(s.startOfMonthMoment).startOf('week');
        },
        get endOfMonthMoment() {
            return moment(s.calendar.startDate).endOf('month');
        },
        get endOfCalendarMoment() {
            return moment(s.endOfMonthMoment).endOf('week');
        },
        get numberOfDays() {
            return s.startOfMonthMoment.daysInMonth();
        },
        get numberOfWeeks() {
            return Math.ceil(s.startOfMonthMoment.daysInMonth() / 7);
        },
        get startOfWeeksMoments() {
            try {
                return Array(s.numberOfWeeks).fill(null).map(function (m, i) { return moment(s.startOfCalendarMoment).add(i, 'week'); });
            }
            catch (e) {
                reportError(e);
                return Array(4).fill(null).map(function (m, i) { return moment(s.startOfCalendarMoment).add(i, 'week'); });
            }
        },
        get startOfWeekDates() {
            return s.startOfWeeksMoments.map(function (w) { return w.format(YYYYMMDD); });
        },
        get weekRowStyle() {
            return s.calendar.fitInnerToAvailableHeight ? {
                flexBasis: 100 / s.numberOfWeeks + "%",
                height: 100 / s.numberOfWeeks + "%",
            } : {};
        }
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement(React.Fragment, null, s.startOfWeekDates.map(function (w) { return React.createElement(BaseCalendarWeek, __assign({ key: w, startDate: w, style: s.weekRowStyle }, p)); }))); } });
}
export default BaseCalendarMonth;
